// import { useEffect, useState } from "react";
// import { useNavigate, useLocation, NavLink } from "react-router-dom";
// import PropTypes from "prop-types";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import Link from "@mui/material/Link";
// import Icon from "@mui/material/Icon";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";
// import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
// import SidenavRoot from "examples/Sidenav/SidenavRoot";
// import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
// import {
//   useMaterialUIController,
//   setMiniSidenav,
//   setTransparentSidenav,
//   setWhiteSidenav,
// } from "context";

// function Sidenav({ color, brand, brandName, routes, ...rest }) {
//   const [controller, dispatch] = useMaterialUIController();
//   const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [lastTap, setLastTap] = useState(0);

//   const collapseName = location.pathname.replace("/", "");
//   let textColor = "white";
//   const userRole = localStorage.getItem("userRole");

//   if (transparentSidenav || (whiteSidenav && !darkMode)) {
//     textColor = "dark";
//   } else if (whiteSidenav && darkMode) {
//     textColor = "inherit";
//   }

//   const closeSidenav = () => setMiniSidenav(dispatch, true);

//   const toggleSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

//   const handleNavBarTap = () => {
//     const now = Date.now();
//     const timeSinceLastTap = now - lastTap;

//     if (timeSinceLastTap < 300 && timeSinceLastTap > 0) {
//       // Double tap detected
//       setMiniSidenav(dispatch, false);
//     } else {
//       // Single tap detected
//       setMiniSidenav(dispatch, true);
//     }
//     setLastTap(now);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setMiniSidenav(dispatch, window.innerWidth < 1200);
//       setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
//       setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => window.removeEventListener("resize", handleResize);
//   }, [dispatch, transparentSidenav, whiteSidenav]);

//   const filteredRoutes = routes.filter((route) => {
//     if (userRole === "BUSINESS_TEAM") {
//       return route.key === "tables" || route.key === "createUsers"; 
//     }
//     if (userRole === "SUPER_ADMIN" || userRole === "ADMIN") {
//       return true;
//     }
//     if (userRole === "CLIENT") {
//       return route.key === "tables"; 
//     }
//     return false; 
//   });

//   // const handleSignOut = () => {
//   //   sessionStorage.clear();
//   //   localStorage.clear();
//   //   navigate("/");
//   // };

//   const handleSignOut = () => {
//     sessionStorage.clear();
//     localStorage.clear();
    
//     // Replace history to prevent going back
//     navigate("/", { replace: true });
  
//     // Use History API to remove the ability to go back
//     window.history.pushState(null, "", window.location.href);
//     window.onpopstate = () => {
//       window.history.go(1);
//     };
//   };
  

//   const renderRoutes = filteredRoutes.map(({ type, name, icon, title, noCollapse, key, href, route }) => {
//     let returnValue;
//     if (type === "collapse") {
//       returnValue = href ? (
//         <Link
//           href={href}
//           key={key}
//           target="_blank"
//           rel="noreferrer"
//           sx={{ textDecoration: "none" }}
//         >
//           <SidenavCollapse
//             name={name}
//             icon={icon}
//             active={key === collapseName}
//             noCollapse={noCollapse}
//           />
//         </Link>
//       ) : (
//         <NavLink key={key} to={route}>
//           <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
//         </NavLink>
//       );
//     } else if (type === "title") {
//       return (
//         <MDTypography
//           key={key}
//           color={textColor}
//           display="block"
//           variant="caption"
//           fontWeight="bold"
//           textTransform="uppercase"
//           pl={3}
//           mt={2}
//           mb={1}
//           ml={1}
//         >
//           {title}
//         </MDTypography>
//       );
//     } else if (type === "divider") {
//       return (
//         <Divider
//           key={key}
//           light={
//             (!darkMode && !whiteSidenav && !transparentSidenav) ||
//             (darkMode && !transparentSidenav && whiteSidenav)
//           }
//         />
//       );
//     }
//     return returnValue;
//   });

//   return (
//     <SidenavRoot
//       {...rest}
//       variant="permanent"
//       ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
//       onClick={handleNavBarTap}
//     >
//       <MDBox pt={3} pb={1} px={4} textAlign="center">
//         <MDBox
//           display={{ xs: "block", xl: "none" }}
//           position="absolute"
//           top={0}
//           right={0}
//           p={1.625}
//           onClick={closeSidenav}
//           sx={{ cursor: "pointer" }}
//         >
//           <MDTypography variant="h6" color="secondary">
//             <Icon sx={{ fontWeight: "bold" }}>close</Icon>
//           </MDTypography>
//         </MDBox>
//         <MDBox component={NavLink} to="/" display="flex" alignItems="center">
//           {brand && <MDBox component="img" src={brand} alt="Brand" width="2rem" />}
//           <MDBox
//             width={!brandName && "100%"}
//             sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
//           >
//             <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
//               {brandName}
//             </MDTypography>
//           </MDBox>
//         </MDBox>
//       </MDBox>
//       <Divider
//         light={
//           (!darkMode && !whiteSidenav && !transparentSidenav) ||
//           (darkMode && !transparentSidenav && whiteSidenav)
//         }
//       />
//       <List>{renderRoutes}</List>
//       <MDBox p={2} mt="auto">
//         <MDButton onClick={handleSignOut} variant="gradient" color={sidenavColor} fullWidth>
//           SIGN OUT
//         </MDButton>
//       </MDBox>
//     </SidenavRoot>
//   );
// }

// Sidenav.defaultProps = {
//   color: "info",
//   brand: "",
// };

// Sidenav.propTypes = {
//   color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
//   brand: PropTypes.string,
//   brandName: PropTypes.string.isRequired,
//   routes: PropTypes.arrayOf(PropTypes.object).isRequired,
// };

// export default Sidenav;



import { useEffect, useState } from "react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  setSelection,
} from "context";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor, selection } =
    controller;
  const location = useLocation();
  const navigate = useNavigate();
  const [lastTap, setLastTap] = useState(0);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const collapseName = location.pathname.replace("/", "");

  const toggleSubmenu = (key) => {
    setOpenSubmenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Auto-expand a parent's submenu when one of its children is the active route,
  // or when the parent's own route is active (e.g. Publication List's children
  // are just alternate views of the same /Tables page)
  useEffect(() => {
    routes.forEach((route) => {
      if (route.collapse) {
        const childActive = route.collapse.some((child) => child.key === collapseName);
        const parentActive = route.route && route.route.replace("/", "") === collapseName;
        if (childActive || parentActive) {
          setOpenSubmenus((prev) => (prev[route.key] ? prev : { ...prev, [route.key]: true }));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapseName]);
  let textColor = "white";
  const userRole = localStorage.getItem("userRole");

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  const toggleSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const handleNavBarTap = () => {
    const now = Date.now();
    const timeSinceLastTap = now - lastTap;

    if (timeSinceLastTap < 300 && timeSinceLastTap > 0) {
      // Double tap detected
      setMiniSidenav(dispatch, false);
    } else {
      // Single tap detected
      setMiniSidenav(dispatch, true);
    }
    setLastTap(now);
  };

  useEffect(() => {
    const handleResize = () => {
      setMiniSidenav(dispatch, true);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    };

    
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch, transparentSidenav, whiteSidenav]);

  const filteredRoutes = routes.filter((route) => {
    if (userRole === "BUSINESS_TEAM") {
      return route.key === "tables" || route.key === "tables-package" || route.key === "createUsers" || route.key === "User List" || route.key === "margin-slab"; 
    }
     if (userRole === "ADMIN") {
      return route.key === "tables" || route.key === "tables-package"; 
    }
    if (userRole === "SUPER_ADMIN" || userRole === "ADMIN") {
      return true;
    }
    if (userRole === "CLIENT") {
      return route.key === "tables" || route.key === "tables-package"; 
    }
    return false; 
  });

  const handleSignOut = () => {
    sessionStorage.clear();
    localStorage.clear();
    
    // Replace history and navigate to login
    navigate("/", { replace: true });
  
    // Remove all previous history entries
    window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);
    
    // Prevent back navigation
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
    };
    
    // Optional: Force reload
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  
  const renderRoutes = filteredRoutes.map(
    ({ type, name, icon, title, noCollapse, key, href, route, collapse: children, selection: routeSelection }) => {
    let returnValue;
    if (type === "collapse") {
      const hasChildren = Array.isArray(children) && children.length > 0;
      const isOpen = !!openSubmenus[key];

      // Items that carry a `selection` value (e.g. Publication List / Social Media)
      // share the same /Tables route, so "active" is based on the selection state
      // rather than the route key alone.
      const isItemActive = routeSelection
        ? collapseName === "Tables" && selection === routeSelection
        : key === collapseName;

      const parentLink = href ? (
        <Link
          href={href}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavCollapse
            name={name}
            icon={icon}
            active={isItemActive}
            noCollapse={noCollapse}
          />
        </Link>
      ) : (
        <NavLink
          to={route}
          onClick={routeSelection ? () => setSelection(dispatch, routeSelection) : undefined}
        >
          <SidenavCollapse name={name} icon={icon} active={isItemActive} />
        </NavLink>
      );

      if (!hasChildren) {
        returnValue = <MDBox key={key}>{parentLink}</MDBox>;
      } else {
        returnValue = (
          <MDBox key={key}>
            <MDBox
              sx={{ position: "relative", cursor: "pointer" }}
              onClick={() => toggleSubmenu(key)}
            >
              {parentLink}
              <MDBox
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleSubmenu(key);
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: isOpen ? "translateY(-50%) rotate(180deg)" : "translateY(-50%)",
                  transition: "transform 0.2s ease",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "inherit",
                }}
              >
                <Icon fontSize="small">expand_more</Icon>
              </MDBox>
            </MDBox>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              <MDBox pl={2}>
                {children.map((child) =>
                  child.type === "selection" ? (
                    <MDBox
                      key={child.key}
                      onClick={() => {
                        setSelection(dispatch, child.selection);
                        if (collapseName !== "Tables") {
                          navigate(child.route);
                        }
                      }}
                      sx={{ cursor: "pointer" }}
                    >
                      <SidenavCollapse
                        name={child.name}
                        icon={child.icon}
                        active={collapseName === "Tables" && selection === child.selection}
                      />
                    </MDBox>
                  ) : (
                    <NavLink key={child.key} to={child.route}>
                      <SidenavCollapse
                        name={child.name}
                        icon={child.icon}
                        active={child.key === collapseName}
                      />
                    </NavLink>
                  )
                )}
              </MDBox>
            </Collapse>
          </MDBox>
        );
      }
    } else if (type === "title") {
      return (
        <MDTypography
          key={key}
          color={textColor}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </MDTypography>
      );
    } else if (type === "divider") {
      return (
        <Divider
          key={key}
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) ||
            (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
      );
    }
    return returnValue;
  });

  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      onClick={handleNavBarTap}
    >
      <MDBox pt={3} pb={1} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <MDBox  display="flex" alignItems="center">
          {brand && <MDBox component="img" src={brand} alt="Brand" width="2rem" />}
          <MDBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            <MDTypography component="h6" variant="button" fontWeight="bold" color={textColor}>
              {/* {brandName} */}Examplad Media 
            </MDTypography>
            <MDTypography component="h6" variant="button" fontWeight="bold" color={textColor}>
               Pricing Portal 
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />
      <List>{renderRoutes}</List>
      <MDBox p={2} mt="auto">
        <MDButton onClick={handleSignOut} variant="gradient" color={sidenavColor} fullWidth>
          SIGN OUT
        </MDButton>
      </MDBox>
    </SidenavRoot>
  );
}

Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
